
import loadable from "@loadable/component";
import componentResolver from "@framework/componentResolver";

export default (route) =>
	loadable(() => import("./GeoPreference.component"), {
		ssr: !!route.ssr,
		resolveComponent: (components) => componentResolver(route, components),
	});
